import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Patient } from 'src/app/core/models/patient/patient';
import { PatientService } from 'src/app/core/services/v2/patient.service';

@Component({
  selector: 'app-profile-contact-preferences',
  templateUrl: './profile-contact-preferences.component.html',
  styleUrls: ['./profile-contact-preferences.component.scss']
})
export class ProfileContactPreferencesComponent implements OnInit {
  isEdit = false;
  contactPreference = this.formBuilder.group({

  });

  constructor(private formBuilder: FormBuilder, private patientService: PatientService) { }
  @Input() patientProfile: Patient;

  ngOnInit() {
  }

  toggleEdit() {
    this.isEdit = !this.isEdit;
  }

  changePreferedType(contact) {
    console.log(contact);
  }

  update() {
    this.patientService.updatePatientDetails(this.patientProfile).subscribe(
      (_) => { },
      (error) => { console.error(error); }
    );
  }
}
